export type UserRole = 'APP_ADMIN' | 'TENANT_ADMIN' | 'TENANT_USER';

export interface TenantProfile {
  id: string;
  name: string;
  description?: string;
  allowedModelTypes: string[];
  defaultModelType: string;
  active: boolean;
  createdAt?: string;
  updatedAt?: string;
  userCount?: number;
  depotCount?: number;
}

export interface TenantInput {
  id: string;
  name: string;
  description?: string;
  allowedModelTypes: string[];
  defaultModelType: string;
  active?: boolean;
}

export interface UserAccount {
  email: string;
  name?: string;
  phone?: string;
  roles: UserRole[];
  tenantId?: string;
  active: boolean;
  lastLoginAt?: string;
  createdAt?: string;
}

export interface UserInput {
  email: string;
  name?: string;
  phone?: string;
  roles: UserRole[];
  tenantId?: string;
  active?: boolean;
}

export interface DepotSummary {
  depotId: string;
  name: string;
  tenantId: string;
  modelType: string;
  active: boolean;
  city?: string;
  region?: string;
  assignedUserCount?: number;
  updatedAt?: string;
  configFilesMap?: Record<string, string>;
}

export interface DepotInput {
  depotId: string;
  name: string;
  tenantId: string;
  modelType: string;
  active?: boolean;
  configFilesMap?: Record<string, string>;
}

export interface DepotUserAssignment {
  depotId: string;
  email: string;
  assignedAt?: string;
}

export interface UserAccessProfile {
  email: string;
  name?: string;
  avatarUrl?: string;
  tenantId?: string;
  tenantName?: string;
  roles: UserRole[];
  assignedDepots: DepotSummary[];
}

export const hasRole = (profile: UserAccessProfile | null, role: UserRole): boolean => {
  if (!profile) {
    return false;
  }
  return profile.roles.includes(role);
};

export const isAppAdmin = (profile: UserAccessProfile | null): boolean => hasRole(profile, 'APP_ADMIN');
export const isTenantAdmin = (profile: UserAccessProfile | null): boolean => hasRole(profile, 'TENANT_ADMIN');
